// import React from "react";
import React, { useState } from "react";
// import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

const TmsPopup = ({ show, handleClose, title, children, onSave, internalCtl }) => {
  return (
    <Modal show={show} onHide={handleClose} centered >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {children}
      </Modal.Body>

      {internalCtl && (
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save
        </Button>
      </Modal.Footer>
      )}
    </Modal>
  );
};

export default TmsPopup ;